const translation = {
  // Navigation
  nav_home: "Home",
  nav_categories: "Categories",
  nav_routes: "Routes",
  nav_map: "Map",
  nav_for_business: "My Business",
  nav_explore_btn: "Explore",
  nav_cat_historical: "Historical Sites",
  nav_cat_food: "Food & Drink",
  nav_cat_entertainment: "Entertainment",
  nav_cat_accommodation: "Accommodation",
  nav_cat_nature: "Nature & Routes",
  nav_cat_sightseeing: "Sightseeing",
  nav_cat_featured: "Featured Venues",

  // Hero
  hero_badge: "The Green Gem of Turkey",
  hero_title_1: "Discover",
  hero_title_2: "Bursa",
  hero_title_3: "360°",
  hero_subtitle: "Historic landmarks, natural beauty, culinary delights — your ultimate guide to every corner of Bursa.",
  hero_search_placeholder: "Search venues, categories or routes...",
  hero_search_btn: "Search",
  hero_stat_1_num: "500+",
  hero_stat_1_label: "Venues to Discover",
  hero_stat_2_num: "85+",
  hero_stat_2_label: "Dining Spots",
  hero_stat_3_num: "12",
  hero_stat_3_label: "Ready-Made Routes",
  hero_stat_4_num: "4.8",
  hero_stat_4_label: "Average Rating",
  hero_quick_label: "Quick Access:",
  hero_quick_history: "Historical",
  hero_quick_food: "Food",
  hero_quick_nature: "Nature",
  hero_quick_hotels: "Hotels",
  hero_quick_fun: "Fun",

  // Categories section
  cat_section_badge: "Categories",
  cat_section_title: "What Would You Like to Explore?",
  cat_section_subtitle: "From historic sites to nature routes, dining to accommodation — everything is here.",
  cat_historical_title: "Historical Sites",
  cat_historical_desc: "Ottoman heritage, UNESCO sites and historic venues",
  cat_historical_count: "120+ venues",
  cat_food_title: "Food & Drink",
  cat_food_desc: "Iskender, stuffed meatballs and Bursa's unique flavors",
  cat_food_count: "85+ restaurants",
  cat_entertainment_title: "Entertainment",
  cat_entertainment_desc: "Adventure parks, activities and nightlife",
  cat_entertainment_count: "60+ venues",
  cat_accommodation_title: "Accommodation",
  cat_accommodation_desc: "Boutique hotels, thermal resorts and holiday villages",
  cat_accommodation_count: "200+ options",
  cat_nature_title: "Nature & Routes",
  cat_nature_desc: "Uludag, lakes, trails and nature walks",
  cat_nature_count: "40+ routes",
  cat_sightseeing_title: "Sightseeing",
  cat_sightseeing_desc: "Museums, bazaars, villages and panoramic viewpoints",
  cat_sightseeing_count: "95+ places",
  cat_featured_title: "Featured Venues",
  cat_featured_desc: "The best addresses recommended by our editors",
  cat_featured_count: "Editor's picks",
  cat_view_all: "View All",

  // Featured section
  featured_badge: "Featured",
  featured_title: "This Week's Recommended Venues",
  featured_subtitle: "The most loved addresses by our editors and visitors.",
  featured_view_all: "View All Venues",
  featured_sponsored: "Sponsored",
  featured_editor: "Editor's Pick",
  featured_open: "Open",
  featured_closed: "Closed",
  featured_details: "View Details",
  featured_directions: "Directions",
  featured_km_away: "km away",
  featured_reviews: "reviews",

  // Routes section
  routes_badge: "Ready-Made Routes",
  routes_title: "Plan Your Bursa",
  routes_subtitle: "Expert-curated route suggestions — choose based on your time and interests.",
  routes_view_all: "All Routes",
  routes_hours: "hrs",
  routes_stops: "stops",
  routes_start: "Start Route",
  routes_difficulty_easy: "Easy",
  routes_difficulty_medium: "Medium",
  routes_difficulty_hard: "Hard",
  routes_day1_title: "Bursa in One Day",
  routes_day1_desc: "Discover the city's most iconic spots in a single day",
  routes_history_title: "Historic Bursa Route",
  routes_history_desc: "A comprehensive history tour tracing Ottoman footsteps",
  routes_food_title: "Food Tour",
  routes_food_desc: "Explore Bursa's best flavors throughout the day",
  routes_family_title: "Family Route",
  routes_family_desc: "A fun and relaxed Bursa tour for kids and families",
  routes_weekend_title: "Weekend Plan",
  routes_weekend_desc: "A comprehensive 2-day Bursa experience, all inclusive",

  // Nearby section
  nearby_badge: "For You",
  nearby_title: "Best Stops Near You",
  nearby_subtitle: "Nearby suggestions from different categories. Historic, delicious and relaxing.",
  nearby_location_btn: "Use My Location",
  nearby_using_location: "Getting location...",
  nearby_view_all: "See More",
  nearby_km_away: "km away",
  nearby_permission_title: "See Nearby Places",
  nearby_permission_desc: "Share your location and we'll instantly show you the nearest historic sites, restaurants and hotels.",
  nearby_no_permission: "Location access denied. Please allow in browser settings.",

  // Campaigns section
  campaigns_badge: "Deals",
  campaigns_title: "Campaigns & Discounts",
  campaigns_subtitle: "Exclusive deals and coupons at Bursa's best venues.",
  campaigns_view_all: "All Campaigns",
  campaigns_expires: "Expires",
  campaigns_get_coupon: "Get Coupon",
  campaigns_sponsored: "Sponsored",
  campaigns_discount: "off",

  // Chatbot
  chatbot_title: "Bursa Assistant",
  chatbot_subtitle: "Ask for route suggestions and venue info",
  chatbot_greeting: "Hello! What would you like to do in Bursa? I'd be happy to suggest the best routes, venues and recommendations for you.",
  chatbot_placeholder: "Ask something...",
  chatbot_send: "Send",
  chatbot_suggestion_1: "What can I do today?",
  chatbot_suggestion_2: "Best historical sites",
  chatbot_suggestion_3: "Suggest a route",
  chatbot_suggestion_4: "Where to go with kids?",
  chatbot_suggestion_5: "Best restaurants",

  // Footer
  footer_tagline: "Discover Bursa 360°",
  footer_desc: "BursaGuide360 is a comprehensive digital city guide platform for everyone visiting Bursa. History, nature, flavors and more, all in one place.",
  footer_links_title: "Quick Links",
  footer_categories_title: "Categories",
  footer_contact_title: "Contact",
  footer_address: "Osmangazi, Bursa, Turkey",
  footer_phone: "+90 224 000 0000",
  footer_email: "info@bursaguide360.com",
  footer_rights: "© 2026 BursaGuide360. All rights reserved.",
  footer_privacy: "Privacy Policy",
  footer_terms: "Terms of Use",
  footer_for_business: "For Business",
  footer_newsletter_title: "Bursa Updates",
  footer_newsletter_desc: "Be the first to hear about new venues and campaigns.",
  footer_newsletter_placeholder: "Your email address",
  footer_newsletter_btn: "Subscribe",

  // Category page
  cat_page_results: "venues found",
  cat_page_no_results: "No results found",
  cat_page_no_results_desc: "Try changing your filters and search again.",
  cat_page_reset_filters: "Clear Filters",
  cat_page_filter_title: "Filters",
  cat_page_filter_district: "District",
  cat_page_filter_sort: "Sort By",
  cat_page_filter_type: "Type",
  cat_page_sort_popular: "Most Popular",
  cat_page_sort_rating: "Highest Rated",
  cat_page_sort_distance: "Nearest First",
  cat_page_sort_newest: "Newest",
  cat_page_filter_open: "Open Now",
  cat_page_filter_sponsored: "Sponsored",
  cat_page_filter_editor: "Editor's Pick",
  cat_page_load_more: "Load More",
  cat_page_showing: "showing",
  cat_page_view_detail: "View Details",
  cat_page_directions: "Directions",
  cat_page_breadcrumb_home: "Home",
  cat_page_breadcrumb_cat: "Categories",
  cat_page_all_categories: "All Categories",
  cat_page_sponsored_banner_title: "Promote Your Business",
  cat_page_sponsored_banner_desc: "Reach your target audience. Get seen by thousands of visitors with sponsored content.",
  cat_page_sponsored_banner_cta: "Advertise",
  cat_page_km: "km",
  cat_page_reviews: "reviews",

  // Common
  common_open: "Open",
  common_closed: "Closed",
  common_sponsored: "Sponsored",
  common_featured: "Featured",
  common_editor_pick: "Editor's Pick",
  common_view_details: "View Details",
  common_get_directions: "Get Directions",
  common_book_now: "Book Now",
  common_explore: "Explore",
  common_see_all: "See All",
  common_km_away: "km away",

  // QR page
  qr_badge: "Welcome!",
  qr_title: "First 5 Things To Do",
  qr_title_accent: "After Leaving the Hotel",
  qr_desc: "5 editor-selected suggestions to make the most of your first hours in Bursa.",
  qr_item1_title: "Go to Extrempark",
  qr_item1_desc: "Best viewpoint in the city. Mountain sled, giant swing and viewing terrace.",
  qr_item1_cta: "Get Ticket",
  qr_item2_title: "Visit Green Mosque",
  qr_item2_desc: "10 minutes from the hotel — the most breathtaking example of Ottoman tilework.",
  qr_item2_cta: "Directions",
  qr_item3_title: "Eat Iskender Kebab",
  qr_item3_desc: "Invented in Bursa in 1867, this dish is the identity of the city.",
  qr_item3_cta: "See Venue",
  qr_item4_title: "Take the Cable Car to Uludag",
  qr_item4_desc: "An 8-minute panoramic journey from the city to the summit.",
  qr_item4_cta: "See Hours",
  qr_item5_title: "Explore Cumalikizik",
  qr_item5_desc: "A 700-year-old Ottoman village. Stone houses, breakfast and nostalgia.",
  qr_item5_cta: "View on Map",
  qr_back: "Back to Full Guide",
  qr_powered: "Powered by BursaGuide360",

  // Sticky
  sticky_label: "Nearby Places",
};

export default translation;
